import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Esito } from 'src/app/common/models/esito';
import { SezioneEsitiFull } from 'src/app/common/models/sezioni/sezione-esiti-full';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { EsitiLiquidatiFormComponent } from '../../../form/esiti-add-liquidati-form';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Liquidato } from '../../../models/liquidato';


@Component({
    selector: 'div [esiti-liquidati-form-add]',
  templateUrl: '../../../form/esiti-add-liquidati-form.html'
})

export class EsitiLiquidatiAddComponent extends EsitiLiquidatiFormComponent {
  liquidato: Liquidato;
  url: string;
  urlAdd: string;

  @Output() onReturn: EventEmitter<SezioneEsitiFull> = new EventEmitter<SezioneEsitiFull>();
  @Input() declare listaLiquidati: any;

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected modalNotifyService: ModalNotifyService) {
    super(operationService, campiForm, helpers, modalNotifyService);
  }


  getLiquidato() {
    return (this.isImportiTotali && !this.inserimento) ? this.esito.liquidati[0] : new Liquidato();
  }

  getRequest(esito: Esito, request: Liquidato, isImportiTotali: boolean, listaLiquidati, isModificaSezioneLiquidati: boolean) {
    this.arrayLiquidati.forEach(liquidato => {
      liquidato.idEsito = this.esito.id;
    })
    if(!isModificaSezioneLiquidati){
      this.operationService.inserisciLiquidati(this.url, this.fascicolo.id, this.fascicolo.idSezioneDatiEconomici ? this.fascicolo.idSezioneDatiEconomici : 'new', this.arrayLiquidati).subscribe((response: any) => this.liquidatoInserito(response));
    }else {
      let liquidato:Liquidato[] = [];
      liquidato.push(this.arrayLiquidati[0]);
      this.operationService.modificaLiquidati(this.url, this.fascicolo.id, this.fascicolo.idSezioneDatiEconomici ? this.fascicolo.idSezioneDatiEconomici : 'new', this.arrayLiquidati).subscribe((response: any) => this.liquidatoInserito(response));
    }
    //this.operationService.insertLiquidati(this.url, this.arrayLiquidati, this.fascicolo.idSezioneDatiEconomici ? this.fascicolo.idSezioneDatiEconomici : 'new', this.fascicolo.id).subscribe((response: any) => this.liquidatoInserito(response));
  }

  liquidatoInserito(response) {
    this.onReturn.emit();
  }

  inizializza(url, sezione: SezioneEsitiFull, esito: Esito, fascicolo: FascicoloFull, 
    inserimento: boolean, urlReadClassificazioni: string, idSezioneClassificazioni: string,
    urlSezioneAltreParti: string, 
    idSezioneAltreParti: string, 
    urlSezioneLegali:string, 
    idSezioneLegali:string,) {
    this.fascicolo = fascicolo;
    this.url = url;
    console.log(url);
    this.esito = esito;
    this.createForm();
    if(esito && esito.liquidati.length > 0){ //sono in modifica
      this.isModificaSezioneLiquidati = true;
      this.arrayLiquidati = esito.liquidati.map(liquidato=>{return liquidato});
      this.liquidatiReset = esito.liquidati.map(liquidato=>{return liquidato}); //copio l'array
      if(this.arrayLiquidati[0].ripartizioneEqua) this.resetRipartizione = true;
      console.log(this.liquidatiReset, this.arrayLiquidati)
      this.inizializzaModifica();
    }
    this.populateSelect(urlSezioneAltreParti, idSezioneAltreParti, urlSezioneLegali,idSezioneLegali);
  }

}
